import * as yup from "yup";

export enum ComplaintType {
  TRAFFIC = 1,
  HEALTH = 2,
  EDUCATION = 3,
  HEALTH_SURVEILANCE = 4,
  ENVIRONMENT = 5,
  FIREFIGHTERS = 6,
  ZOONOSIS = 7,
  DEMAND = 8
}

const complaintDescription = {
  [ComplaintType.TRAFFIC]: "Infraestrutura/Trânsito",
  [ComplaintType.HEALTH]: "Saúde",
  [ComplaintType.EDUCATION]: "Educação",
  [ComplaintType.HEALTH_SURVEILANCE]: "Vigilância Sanitária",
  [ComplaintType.ENVIRONMENT]: "Meio Ambiente",
  [ComplaintType.FIREFIGHTERS]: "Defesa Civil/Corpo de bombeiros",
  [ComplaintType.ZOONOSIS]: "Zoonoses",
  [ComplaintType.DEMAND]: "Reclamação/Outros"
};

export function getComplaintDescription(type: number) {
  const description = complaintDescription[type as ComplaintType];
  if (!description) {
    throw new Error("Invalid complaint type. Value received: " + type);
  }
  return description;
}

export type ComplaintStatus =
  | "Encerrada"
  | "Não atendida"
  | "Respondida pelo usuário"
  | "Respondida pela prefeitura";

export const complaintSchema = yup.object().shape({
  title: yup
    .string()
    .required("Título é obrigatório.")
    .min(2, "Mínimo de dois caracteres.")
    .max(20, "Máximo de 20 caracteres."),
  type: yup
    .number()
    .typeError("Tipo de manifestação é obrigatório")
    .oneOf(
      Object.values(ComplaintType)
        .map((x) => +x)
        .filter((x) => !isNaN(x)),
      "Tipo de manifestação inválida"
    ),
  description: yup
    .string()
    .required("Descrição é obrigatória.")
    .min(2, "Deve conter no mínimo dois caracteres.")
    .max(250, "Deve conter no máximo 250 caracteres.")
  //photo: yup.mixed().required("Imagem é obrigatória.")
});

export type ComplaintFormData = {
  title: string;
  type: ComplaintType;
  description: string;
  photo: File;
};

export const complaintStatusMap: Record<ComplaintStatus, number> = {
  "Não atendida": 1,
  "Respondida pela prefeitura": 2,
  "Respondida pelo usuário": 3,
  Encerrada: 4
};
